import styled from "styled-components";
import HomeBackground from './../../assets/img/home.jpg'
import ImgLogo from './../../assets/img/logo.png'

export const HomeContainer = styled.section`
  height: 100vh;
  width: 100%;
  background: url(${HomeBackground});
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: grid;
  align-items: center;
  justify-items: center;
`
export const Logo = styled.img.attrs({ src: `${ImgLogo}`})`
  width: 260px;
  transition: .5s all;
  @media (min-width: 575px) {
    width: 300px;
    transition: .5s all;
  }
  @media (min-width: 768px) {
    width: 360px;
    transition: .5s all;
  }
  @media (min-width: 1200px) {
    width: 400px;
    transition: .5s all;
  }
`